/**
 * Agents block registration.
 *
 * @package
 * @since   3.5.0
 */

import { registerBlockType } from '@wordpress/blocks';

import metadata from './block.json';
import Edit from './edit';
import icon from '../shared/icon';

registerBlockType( metadata.name, {
	icon,
	edit: Edit,
	save: () => null,
} );
